import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = {
  key: 0,
  class: "form-label text-muted"
}
const _hoisted_3 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_4 = ["for"]
const _hoisted_5 = { class: "text-paragraph flex-fill py-3" }
const _hoisted_6 = ["value", "id", "name"]
const _hoisted_7 = {
  key: 0,
  class: "fa-solid fa-check fa-xl text-secondary radio-checked"
}
const _hoisted_8 = {
  key: 1,
  class: "radio-unchecked"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RadioInput',
  props: {
    model: { default: () => ({}) },
    label: { default: "" },
    options: { default: () => [] },
    required: { type: Boolean, default: false },
    name: { default: "" }
  },
  emits: ["onChange"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const onChange = (event: Event) => {
  emit("onChange", (event.target as HTMLInputElement).value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
          _createTextVNode(_toDisplayString(__props.label) + " ", 1),
          (__props.required)
            ? (_openBlock(), _createElementBlock("i", _hoisted_3, "*"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item, index) => {
      return (_openBlock(), _createElementBlock("label", {
        key: 'option_' + index,
        for: __props.name + '_' + index,
        class: _normalizeClass(["d-flex align-items-center mb-0 cursor-pointer", { 'border-bottom': __props.options.length > index + 1 }])
      }, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(item.name || item.title), 1),
        _withDirectives(_createElementVNode("input", {
          hidden: "",
          type: "radio",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.model.$model) = $event)),
          value: item.id,
          id: __props.name + '_' + index,
          name: __props.name,
          onChange: _cache[1] || (_cache[1] = ($event: any) => (onChange($event)))
        }, null, 40, _hoisted_6), [
          [_vModelRadio, __props.model.$model]
        ]),
        (__props.model.$model == item.id)
          ? (_openBlock(), _createElementBlock("i", _hoisted_7))
          : (_openBlock(), _createElementBlock("i", _hoisted_8))
      ], 10, _hoisted_4))
    }), 128))
  ]))
}
}

})